export default import.meta.ROLLDOWN_FILE_URL_IK74R0yTWCNjI0r4yMeH1g